import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { message, Upload, Spin } from 'antd'

export default function FacebodyLogin() {
  const { oid } = useParams()
  const navigate = useNavigate()
  const [categoryDetail, setCategoryDetail] = useState({})
  const [currentLoginType, setCurrentLoginType] = useState(1)
  const [nameInput, setNameInput] = useState('')
  const [idNumberInput, setIdNumberInput] = useState('')
  const [nation, setNation] = useState('')
  const [sex, setSex] = useState('')
  const [uploading, setUploading] = useState(false)

  useEffect(() => {
    document.title = '人脸核身学生登录'

    axios.post('/c/facebody/category/detail/get', { 
      facebody_category_oid: oid 
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setCategoryDetail(response.data)
          setCurrentLoginType(response.data.login_type === 2 ? 2 : 1)
        } else {
          message.warning(response.msg)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }, [oid])

  const handleLogin = (autoData) => {
    if (currentLoginType !== 2) {
      if (!nameInput) {
        message.warning('请输入姓名')
        return false
      }
      if (!idNumberInput) {
        message.warning('请输入身份证号')
        return false
      }
    }

    const payload = {
      facebody_category_oid: oid,
      name: autoData?.name || nameInput.trim(),
      id_number: autoData?.id_number || idNumberInput.trim(),
      nation: autoData?.nation || nation.trim(),
      sex: autoData?.sex || sex.trim()
    }
    
    axios.post('/c/facebody/login', payload)
      .then(function (response) {
        if (response.errcode === 0) {
          message.success('登录成功')
          sessionStorage.setItem('token', response.data.access_token)
          if (response.data.verification_status === 2) {
            navigate('/success', { state: response.data.report })
          } else {
            navigate('/student/info')
          }
        } else if (response.errcode === 2) {
          navigate('/lock')
        } else {
          message.warning(response.msg)
        }
      })
      .catch(function (error) {
        console.error('网络请求异常:', error);
      })
  }

  const handleSwitchLoginType = () => {
    setCurrentLoginType(currentLoginType === 2 ? 1 : 2)
  }

  const handlePhotoUpload = (file) => {
    setUploading(true)
  
    const formData = new FormData()
    formData.append('idcard_image', file)
    axios.post('/c/facebody/idcard_info/identification', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then(res => {
        if (res.errcode === 0) {
          const { id_number, name, nation, sex } = res.data
          setIdNumberInput(id_number)
          setNameInput(name)
          setNation(nation)
          setSex(sex)

          handleLogin({
            id_number,
            name,
            nation,
            sex
          })
        } else {
          message.warning(res.msg)
        }
      })
      .catch(err => console.error(err))
      .finally(() => setUploading(false))
    return false
  }

  return (
    <Spin spinning={uploading}>
      <div className='facebody-login-page'>
        <div className='facebody-login-bg'></div>
        {categoryDetail.merchant_logo && (
          <img className='facebody-login-merchantLogo' src={categoryDetail.merchant_logo} alt="" />
        )}
        <div className='facebody-login-merchantName'>{categoryDetail.merchant_name}</div>
        <div className='facebody-login-categoryName'>{categoryDetail.category_name}</div>
        <div className='facebody-login-descrption'>{categoryDetail.category_descrption}</div>

        {currentLoginType === 1 && (
          <form className='facebody-login-form'>
            <div className='facebody-login-item'>
              <label className='facebody-login-label' htmlFor="studentName">姓名</label>
              <input className='facebody-login-input'
                type='text'
                id='studentName'
                placeholder='请输入姓名'
                value={nameInput}
                onChange={(e) => setNameInput(e.target.value)}
              />
            </div>
            <div className='facebody-login-item'>
              <label className='facebody-login-label' htmlFor="studentNumber">身份证号</label>
              <input className='facebody-login-input'
                type='text'
                id='studentNumber'
                placeholder='请输入身份证号'
                value={idNumberInput}
                onChange={(e) => setIdNumberInput(e.target.value)}
              />
            </div>
            <button
              className='facebody-login-button'
              type='button'
              onClick={handleLogin}>
              登录
            </button>
          </form>
        )}

        {currentLoginType === 2 && (
          <div className='facebody-login-photo'>
            <Upload
              accept="image/*"
              beforeUpload={handlePhotoUpload}
              showUploadList={false}
              disabled={uploading}
            >
            <img src="/images/idcard.jpg" alt='' />
            </Upload>
            <div className='facebody-login-prompt'>请上传核验学生的身份证照片</div>
          </div>
        )}

        {categoryDetail.allow_switch_login_type === 1 && (
          <div
            className='facebody-login-switch'
            onClick={handleSwitchLoginType}>
            <svg className='facebody-login-switch-icon' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 7h13M17 7l-3.5-3.5M17 7l-3.5 3.5M20 17H7M7 17l3.5-3.5M7 17l3.5 3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span>{currentLoginType === 2 ? '姓名和身份证号登录' : '身份证照片登录'}</span>
          </div>
        )}
      </div>
    </Spin>
  )
}
